import { ApplicationsEnum } from '@actassa/api';

export class SetUserOnline {
    public static readonly type = '[Root state] Set user online';

    constructor(public uuid: string, public name: string, public app: ApplicationsEnum) {}
}
